import { Component, ElementRef, Input } from '@angular/core';

@Component({
	standalone: false,
	selector: 'save-btn',
	template: /*language=html*/ `
		<button
			[tabindex]="tabInd"
			class="btn"
			[class.disabled]="readonly"
			[class.error]="error"
			[class.errorWithText]="errorText != null"
		>
			<div [hidden]="loading || success || error"><ng-content></ng-content></div>
			<div class="inner" *ngIf="loading"><visiba-svg a="Loader"></visiba-svg>{{ 'Common.Button.Saving' | translate }}...</div>
			<div class="inner" *ngIf="success"><visiba-svg a="CheckWithCircle"></visiba-svg>{{ 'Common.Button.Saved' | translate }}</div>
			<svg *ngIf="error" viewBox="0 0 200 200" (click)="errorText = null">
				<path
					class="fill"
					d="M160.423,155.475l-8.099,8.131c-2.449,2.459-6.429,2.46-8.88,0.003l-45.071-45.192l-45.071,45.192
		                    c-2.45,2.457-6.431,2.456-8.88-0.003l-8.1-8.131c-2.438-2.447-2.436-6.405,0.003-8.851l44.901-45.023L36.325,56.58
		                    c-2.439-2.446-2.44-6.404-0.003-8.851l8.1-8.131c2.449-2.459,6.429-2.46,8.88-0.003l45.071,45.192l45.071-45.192
		                    c2.451-2.457,6.431-2.456,8.88,0.003l8.099,8.131c2.438,2.447,2.436,6.405-0.003,8.851l-44.901,45.022l44.901,45.023
		                    C162.859,149.07,162.86,153.028,160.423,155.475z"
				></path>
			</svg>
		</button>
		<div class="errorText" *ngIf="errorText != null" [class.left]="errorTextLeft">
			<svg class="svg_X" viewBox="0 0 200 200" (click)="errorText = null">
				<path
					class="fill"
					d="M160.423,155.475l-8.099,8.131c-2.449,2.459-6.429,2.46-8.88,0.003l-45.071-45.192l-45.071,45.192
		                        c-2.45,2.457-6.431,2.456-8.88-0.003l-8.1-8.131c-2.438-2.447-2.436-6.405,0.003-8.851l44.901-45.023L36.325,56.58
		                        c-2.439-2.446-2.44-6.404-0.003-8.851l8.1-8.131c2.449-2.459,6.429-2.46,8.88-0.003l45.071,45.192l45.071-45.192
		                        c2.451-2.457,6.431-2.456,8.88,0.003l8.099,8.131c2.438,2.447,2.436,6.405-0.003,8.851l-44.901,45.022l44.901,45.023
		                        C162.859,149.07,162.86,153.028,160.423,155.475z"
				></path>
			</svg>
			<div class="arrow"></div>
			<div>{{ errorText }}</div>
		</div>
	`,
	host: {
		'[class.readonly]': 'readonly',
	},
})
export class VisibaSaveButtonComponent {
	@Input() tabInd: number = 0;
	@Input() action: string = 'save';
	@Input() loading: boolean = false;
	@Input() readonly: boolean = false;
	@Input() success: boolean = false;
	@Input() error: boolean = false;
	@Input() errorText: string = null;

	errorTextLeft: boolean = false;
	timer: number = null;

	constructor(private _elem: ElementRef) {}

	normalizeTimer(seconds) {
		this.timer = window.setTimeout(() => {
			this.normalize();
		}, seconds * 1000);
	}

	normalize() {
		this.loading = false;
		this.success = false;
		this.error = false;
		this.errorText = null;
	}

	isLoading() {
		this.normalize();
		this.loading = true;
	}

	isSuccess() {
		this.normalize();
		this.success = true;
		this.normalizeTimer(3);
	}

	isError(message: string = null, autoCheckErrorPosition: boolean = true) {
		this.normalize();
		if (message === null) {
			this.normalizeTimer(3);
			this.error = true;
		} else {
			this.errorText = message;
			this.normalizeTimer(200);

			if (autoCheckErrorPosition) this.checkErrorTextPosition();
		}
	}

	checkErrorTextPosition() {
		this.errorTextLeft = false;
		let elRects = this._elem.nativeElement.getClientRects()[0];
		if (!elRects) return;
		if (document.body.clientWidth < elRects.left + elRects.width + 160) this.errorTextLeft = true;
	}
}
